import { LicensesType } from 'models/IUserData'

export enum WidgetSize {
	SMALL = 'small', // 1x1
	MEDIUM = 'medium', // 2x1
	LARGE = 'large', // 2x2
	FULL = 'full', // 6x2
}

export enum WidgetType {
	ANALYTICS = 'ANALYTICS',
	STATISTICS = 'STATISTICS',
	NOTIFICATIONS = 'NOTIFICATIONS',
	QUICK_ACTIONS = 'QUICK_ACTIONS',
	ACTUAL_YIELD = 'ACTUAL_YIELD',
	IDENTIFICATE = 'IDENTIFICATE',
	FATNESS_DONUT_CHART = 'FATNESS_DONUT_CHART',
	DISPOSE_RECOMMENDED = 'DISPOSE_RECOMMENDED',
	REJECTED_MILK_YIELD = 'REJECTED_MILK_YIELD',
	PSV_HERD_STRUCTURE = 'PSV_HERD_STRUCTURE',
	HERD_STRUCTURE = 'HERD_STRUCTURE',
	MILKING_DEVIATIONS = 'MILKING_DEVIATIONS',
	LAMENESS_LINE_CHART = 'LAMENESS_LINE_CHART',
	FEED_AVAILABILITY = 'FEED_AVAILABILITY',
	DEVIATIONS_FEED_TABLE = 'DEVIATIONS_FEED_TABLE',
	LARGE_HERD_STRUCTURE = 'LARGE_HERD_STRUCTURE',
	MILKY_HERD = 'MILKY_HERD',
	DRY_HERD = 'DRY_HERD',
	HERD_ALL = 'HERD_ALL',
	IDENTIFICATE_WITH_NOTIF = 'IDENTIFICATE_WITH_NOTIF',
	IDENTIFICATE_WITH_NOTIF_MEDIUM = 'IDENTIFICATE_WITH_NOTIF_MEDIUM',
	FEED_CONSUMPTION = 'FEED_CONSUMPTION',
	FEED_CONSUMPTION_SMALL = 'FEED_CONSUMPTION_SMALL',
	REMAINING_FEED_SMALL = 'REMAINING_FEED_SMALL',
	FEED_CONSUMPTION_LINE_CHART = 'FEED_CONSUMPTION_LINE_CHART',
	FEED_CONSUMPTION_BAR_CHART = 'FEED_CONSUMPTION_BAR_CHART',
	REMAINING_FEED_PROCENT = 'REMAINING_FEED_PROCENT',
	PSV_AVG_MILKY = 'PSV_AVG_MILKY',
	PSV_AVG_DRY = 'PSV_AVG_DRY',
	PSV_DYNAMIC_CHART = 'PSV_DYNAMIC_CHART',
	PSV_WIDGET = 'PSV_WIDGET',
	FEED_AVAILABILITY_AVG = 'FEED_AVAILABILITY_AVG',
	FEED_PLAN_COMPLIANCE = 'FEED_PLAN_COMPLIANCE',
	CRIT_FATNESS_HEAD = 'CRIT_FATNESS_HEAD',
	LAME_HEADS = 'LAME_HEADS',

	DEVIATIONS_PARALLEL = 'DEVIATIONS_PARALLEL',
	DEVIATIONS_CAROUSEL = 'DEVIATIONS_CAROUSEL',

	AVG_CONNECT_TIME = 'AVG_CONNECT_TIME ',
	AVG_MILKING_TIME = 'AVG_MILKING_TIME',
	AVG_MILK_YIELD = 'AVG_MILK_YIELD',
	MILK_YIELD_LINEAR_CHART = 'MILK_YIELD_LINEAR_CHART',
} // Будет расширятся по мере добавления/создания новых виджетов

// Конфигурация виджета
export interface WidgetConfig {
	id: WidgetType
	type: WidgetType
	size: WidgetSize
	title?: string
	data?: Record<string, unknown>
	isVisible?: boolean
	isEditable?: boolean
	license?: LicensesType // Лицензия, необходимая для отображения виджета
}

// Строка виджетов на дашборде
export interface WidgetRow {
	id: string // Уникальный ID строки
	widgets: WidgetConfig[] // Виджеты в этой строке
	rowIndex: number // Индекс строки (для сортировки)
}

// Размеры виджетов в grid units
export interface WidgetDimensions {
	width: number // количество колонок
	height: number // количество строк
	minWidth: number // минимальная ширина в px
	minHeight: number // минимальная высота в px
}

// Конфигурация сетки
export interface GridConfig {
	columns: number
	rowHeight: number
	margin: [number, number] // [horizontal, vertical]
	containerPadding: [number, number] // [horizontal, vertical]
}

// Layout для всего dashboard
export interface DashboardLayout {
	widgets: WidgetConfig[]
	gridConfig: GridConfig
}

// Responsive breakpoints
export interface GridBreakpoints {
	lg: number
	md: number
	sm: number
	xs: number
	xxs: number
}

export interface ResponsiveGridCols {
	lg: number
	md: number
	sm: number
	xs: number
	xxs: number
}

// API типы для интеграции с бэкендом
export interface ApiWidgetConfig {
	id: string
	type: string
	size: string
	title: string
	position: {
		x: number
		y: number
		width: number
		height: number
	}
	data?: Record<string, unknown>
	isVisible: boolean
	isEditable: boolean
	createdAt: string
	updatedAt: string
}

export interface ApiDashboardLayout {
	id: string
	userId: string
	name: string
	widgets: ApiWidgetConfig[]
	isDefault: boolean
	createdAt: string
	updatedAt: string
}
